<template>
  <div class="wrapper main-container">
    <!-- 业务员产品 -->
    <div style="overflow: hidden">
      <div class="lf">请输入一个业务员姓名来获取ta的专属投保链接</div>
      <Button class="rf" type="primary" ghost @click="backUrl()">返回</Button>
    </div>
    <Form :inline="true" ref="formRef" :model="searchParams" :label-width="80" class="search-box one-btn min">
      <FormItem label="机构/团队">
        <selectTree type="1" v-model="searchParams.applyOrgId" @change="selectTreeChange"></selectTree>
      </FormItem>
      <FormItem label="业务员姓名">
        <Input v-model="searchParams.userName" placeholder="请输入" clearable />
      </FormItem>
      <div class="btn-item">
        <Button type="primary" @click="search()">查询</Button>
      </div>
    </Form>
    <loading :isShow="listLoading" />
    <div class="table-box">
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="copyUrl">
          <div style="width: 100%; position: relative">
            <a :class="{ 'disabled': row.disabled || !row.insureUrl }" @click="$route.query.fromGroup == 1 ? goLinkList(row) : copyLink(row, 'insureUrl')">
              <input class="insureUrl_target" style="position: absolute; top: -1000000000000px" :value="row.insureUrl" type="text" />
              {{ $route.query.fromGroup == 1 ? '在线录单' : '复制链接' }}
            </a>
            <Poptip style="position: absolute" trigger="hover" content="content" :transfer="true" v-if="row.disabled || !row.insureUrl">
              <span class="wenhao">?</span>
              <div slot="content">
                <span v-if="row.errorText">{{ row.errorText }}</span>
              </div>
            </Poptip>
          </div>
        </template>
        <!-- 代投链接 -->
        <template slot-scope="{ row }" slot="copyUrl2">
          <div style="width: 100%; position: relative">
            <a :class="{ 'disabled': row.disabled || !row.insureUrl2 }" @click="copyLink(row, 'insureUrl2')"> 复制代投链接 </a>
            <Poptip style="position: absolute" trigger="hover" content="content" :transfer="true" v-if="row.disabled || !row.insureUrl">
              <span class="wenhao">?</span>
              <div slot="content">
                <span v-if="row.errorText">{{ row.errorText }}</span>
              </div>
            </Poptip>
          </div>
        </template>
        <template slot-scope="{ row }" slot="veuqr">
          <div style="width: 100%; position: relative">
            <a
              @click="downLoad(row)"
              :class="{ 'disabled': row.disabled || !row.insureUrl }"
              v-if="row.sourceType == 3 || (row.dockChannel == 3 && (row.productCategory == 1 || row.productCategory == 2))"
            >
              下载二维码
            </a>
            <Poptip
              v-else
              :class="{ 'disabled': row.disabled || !row.insureUrl }"
              trigger="hover"
              content="content"
              :transfer="true"
              :transfer-class-name="'c' + row.userId"
            >
              <a @click="downLoad(row)" :class="{ 'disabled': row.disabled || !row.insureUrl }"> 下载二维码 </a>
              <div slot="content">
                <vueQr :text="row.insureUrl" :size="120" :margin="0" />
              </div>
            </Poptip>
            <Poptip style="position: absolute" trigger="hover" content="content" :transfer="true" v-if="row.disabled || !row.insureUrl">
              <span class="wenhao">?</span>
              <div slot="content">
                <span v-if="row.errorText">{{ row.errorText }}</span>
              </div>
            </Poptip>
          </div>
        </template>
        <template slot-scope="{ row }" slot="action">
          <div class="detail">
            <div @click="showAllInfoMask(row)">
              <span class="icon icon-edit"></span>
              <span>编辑</span>
            </div>
            <div @click="toDeleteOrganization(row)">
              <span class="icon icon-remove"></span>
              <span>删除</span>
            </div>
          </div>
        </template>
      </Table>
    </div>
    <div class="pageBox" style="margin-top: 20px">
      <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" />
    </div>

    <select-grade-modal ref="selectGradeModal"></select-grade-modal>
  </div>
</template>

<script>
import vueQr from 'vue-qr';
import selectTree from '@/components/system/selectTree3';
import selectGradeModal from './components/selectGradeModal';
import { pageTool, common } from '@/api/mixins';
export default {
  mixins: [pageTool, common],
  components: {
    selectGradeModal,
    selectTree,
    vueQr
  },
  props: {},
  data() {
    return {
      searchParams: {},
      total: 0,
      pageNo: 1,
      pageSize: 10,
      insureType: '',
      columns: []
    };
  },
  watch: {},
  computed: {},
  created() {},
  async mounted() {
    this.insureType = this.$route.query.insureType || '';
    this.initColumn();
    this.searchParams.productCode = this.$route.query.productCode;
    this.initListAjax('/buz/userBase/queryUserProduct');
  },
  methods: {
    backUrl(){
        this.back(this.$route.query.backUrl)
    },
    //复制链接
    copyLink(item, key) {
      if (item.sourceType == 3 || (item.dockChannel == 3 && (item.productCategory == 1 || item.productCategory == 2))) {
        //团险
        this.$refs.selectGradeModal.open(item, 'copyLink');
        return;
      }
      this.$units.copyUrl(item[key], false, true);
    },
    goLinkList(item) {
      if (item.sourceType == 3 || (item.dockChannel == 3 && (item.productCategory == 1 || item.productCategory == 2))) {
        this.$http({
          type: 'GET',
          url: '/buz/productBase/startPolicy',
          query: {
            productCode: item.productCode,
            userId: item.userId,
            grade: '',
            type: 2,
            broker: true
          }
        }).then(res => {
          window.open(res.data);
        });
      } else {
        window.open(item.insureUrl);
      }
    },
    //下载图片
    downLoad(item) {
      if (item.sourceType == 3 || (item.dockChannel == 3 && (item.productCategory == 1 || item.productCategory == 2))) {
        //团险
        this.$refs.selectGradeModal.open(item, 'downLoad');
        return;
      }
      const outer = document.querySelectorAll('.c' + item.userId);
      var url = outer[0].querySelector('img').src;
      var a = document.createElement('a');
      var event = new MouseEvent('click');
      // 下载图名字
      a.download = item.productName;
      a.href = url;
      // 合成函数，执行下载
      a.dispatchEvent(event);
    },
    // 组织选择
    selectTreeChange(data) {
      if (data.nodeType == 1) {
        //机构
        this.searchParams.organizationId = data.id;
        this.searchParams.groupId = '';
      } else if (data.nodeType == 2) {
        //团队
        this.searchParams.organizationId = '';
        this.searchParams.groupId = data.id;
      } else {
        this.searchParams.organizationId = '';
        this.searchParams.groupId = '';
      }
    },
    search() {
      this.$refs.formRef.validate().then(isok => {
        if (isok) {
          this.searchAjax();
        }
      });
    },
    setListParams(params) {
      this.listLoading = true;
      params.queryType = 1;
      params.isGift = this.$route.query.isGift;
      this.listUrl = '/buz/userBase/queryUserProduct';
    },
    listCallback(resData) {
      resData.data.forEach(item => {
        // 统一改为客户链接
        item.insureUrl = item.insureUrl.replace('/product/app/', '/product/');
        if (this.insureType.includes('2')) {
          // 如果可以代投，则添加一个链接
          item.insureUrl2 = item.insureUrl.replace('/product/', '/product/app/');
        }
        if (item.enableFlag == 0 || item.orgStatus == 2 || item.workingState == 0 || item.isSus == 1 || item.qualificationFlag != 1) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
        let errorText;
        if (item.enableFlag == 0) {
          errorText = '业务员已禁用，暂不支持投';
        } else if (item.orgStatus == 2) {
          errorText = '此机构已停业，业务员暂不支持投保';
        } else if (item.workingState == 0) {
          errorText = '业务员已离职，暂不支持投保';
        } else if (item.isSus == 1) {
          errorText = '业务员已停职，暂不支持投保';
        } else if (item.qualificationFlag != 1) {
          errorText = '业务员执业资格未认证，暂不支持投保';
        } else {
          errorText = '暂无投保二维码';
        }
        item.errorText = errorText;
      });
    },
    initColumn() {
      this.columns = [
        {
          title: '业务员姓名',
          key: 'userName',
          align: 'center'
        },
        {
          title: '所属机构',
          key: 'organizationName',
          align: 'center'
        },
        {
          title: '所属团队',
          key: 'groupName',
          align: 'center'
        },
        {
          title: '产品名称',
          key: 'productName',
          minWidth: 200,
          align: 'center'
        }
      ];
      if (this.$route.query.fromGroup == 1 || this.insureType.includes('1') || this.insureType.includes('4') || this.insureType.includes('5') || this.insureType.includes('7')) {
        this.columns.push({
          title: this.$route.query.fromGroup == 1 ? '操作' : '投保链接',
          align: 'center',
          slot: 'copyUrl'
        });
      }
      // 团险不显示
      if (this.$route.query.fromGroup != 1) {
        // 可以代投时显示
        if (this.insureType.includes('2') || this.insureType.includes('6')) {
          this.columns.push({
            title: '代投链接',
            align: 'center',
            slot: 'copyUrl2'
          });
        }
        // 可以自投的
        if (this.insureType.includes('1') || this.insureType.includes('4') || this.insureType.includes('5') || this.insureType.includes('7')) {
          this.columns.push({
            title: '投保二维码',
            key: 'leaderName',
            align: 'center',
            slot: 'veuqr'
          });
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
  .search-box {
    margin-bottom: 15px;
  }
  /deep/ .ivu-col {
    width: 402px;
  }
  .lf {
    float: left;
  }
  .rf {
    float: right;
  }
  .searchBox {
    display: flex;
    /deep/ .ivu-form .ivu-form-item-label {
      text-align: left;
    }
    /deep/ .ivu-form-item-content {
      margin-right: 30px;
    }
    .left {
      float: left;
      width: 100%;
    }
    .right {
      float: right;
      /deep/ .ivu-btn {
        width: 80px;
        height: 30px;
        margin-top: 15px;
      }
    }
  }

  .disabled {
    filter: grayscale(1);
    pointer-events: none;
  }
  .wenhao {
    margin-left: 3px;
    width: 15px;
    height: 15px;
    border-radius: 15px;
    background: transparent;
    border: 1px solid #ccc;
    color: #ccc;
    display: inline-block;
    text-align: center;
    line-height: 14px;
    font-size: 14px;
    cursor: pointer;
    top: 50%;
  }
  .tableBox {
    &/deep/.ivu-table-cell-slot {
      width: 100%;
    }
  }
}
</style>
